import { render, staticRenderFns } from "./SVGComponent.vue?vue&type=template&id=3e22d532"
import script from "./SVGComponent.vue?vue&type=script&lang=js"
export * from "./SVGComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports